import { useCallback, useEffect, useState } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { Alert, message, Select, Form, Popconfirm } from 'antd';
import srv from '../../../services';
import {
 SubmitButton,
 RangePicker,
 Col,
 BaseForm,
} from './StoryPayment.styled';
import TableStoryPayment from './TableStoryPayment';
import moment, { Moment } from 'moment';
import DataGrid from '../../Shared/DataGrid/DataGrid';
import { StoryPaymentColumns } from '../../Shared/columns/StoryPaymentColumns';
import { StoryPaymentConvertData } from '../../Shared/columns/StoryPaymentConvertData';
import SnackBar from '../../Shared/SnackBar';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { AppDispatch } from '../../../store/store';
import { getContract } from '../../../store/reducers/getContractSlice';
import { RootState } from '../../../store/store';
import { storyPaymentReceiptResponseStatus } from '../../../store/reducers/storyPaymentReceiptResponseStatusSlice';

interface StoryPaymentReceiptObject {
 errorStatus: boolean;
 message: string;
 show: boolean;
}

export default function StoryPayment() {
 const {
  data,
  form,
  error,
  isLoading,
  isSuccess,
  period,
  setPeriod,
  ...formProps
 } = useContractsPayment();
 const { contracts } = useDicts();

 const dispatch = useDispatch<AppDispatch>();

 const [mainColumns, setMainColumns] = useState(StoryPaymentColumns());

 const storyPaymentReceiptResponseStatusData = useSelector(
  (state: RootState) => state.storyPaymentReceiptResponseStatus,
  shallowEqual,
 );

 useEffect(() => {
  const storyPaymentColumns = StoryPaymentColumns();

  setMainColumns(storyPaymentColumns);
 }, []);

 useEffect(() => {
  const picker = [moment(moment().subtract(12, 'months')), moment(new Date())];

  setPeriod({
   Picker: picker,
  });

  form.setFieldsValue({
   period: picker,
  });

  const obj: StoryPaymentReceiptObject = {
   errorStatus: true,
   message: '',
   show: false,
  };
  dispatch(storyPaymentReceiptResponseStatus(obj));
 }, []);

 const handleContractChange = (e: any) => {
  const contract = contracts.filter((x: any) => x.aisId === e)[0];
  dispatch(getContract(contract));
 };

 return (
  <>
   <BaseForm
    layout="vertical"
    form={form}
    {...formProps}
    style={{
     display: 'flex',
     width: '100%',
     flexDirection: 'row',
     justifyContent: 'flex-start',
     justifyItems: 'flex-start',
     alignContent: 'flex-start',
     alignItems: 'flex-start',
     textAlign: 'left',
    }}
   >
    <div style={{ minWidth: 400 }}>
     <Col>
      <Form.Item
       name="contractId"
       label="№ Договора"
       rules={[{ required: true }]}
       style={{ maxWidth: '400px', marginRight: 0 }}
      >
       <Select
        showSearch
        optionFilterProp="children"
        placeholder="Выберите № договора"
        loading={isLoading}
        onChange={handleContractChange}
       >
        {contracts?.map((item) => (
         <Select.Option key={item.id} value={item.aisId} o>
          {item.resources
           ? `${item.printNumber} - ${item.resources}`
           : item.printNumber}
         </Select.Option>
        ))}
       </Select>
      </Form.Item>
     </Col>
    </div>

    <Col flex={1.3}>
     <Form.Item
      name="period"
      label="Период запроса"
      rules={[{ required: true }]}
      style={{ maxWidth: '400px' }}
     >
      <RangePicker allowClear format="DD.MM.YYYY" style={{ width: '100%' }} />
     </Form.Item>
    </Col>

    {/* <Col flex={2.4}>
     <SubmitButton
      loading={isLoading}
      onClick={form.submit}
      disabled={isLoading}
     >
      Запросить
     </SubmitButton>
    </Col> */}

    {!!error && (
     <Alert
      type="error"
      showIcon
      message={error}
      style={{ width: '100%', marginTop: '10px' }}
     />
    )}

    {storyPaymentReceiptResponseStatusData &&
     !storyPaymentReceiptResponseStatusData?.errorStatus &&
     storyPaymentReceiptResponseStatusData.show && (
      <Alert
       type="error"
       showIcon
       closable
       message={storyPaymentReceiptResponseStatusData.message}
       style={{
        width: `${storyPaymentReceiptResponseStatusData.message ? storyPaymentReceiptResponseStatusData.message.length * 10 : 400}px`,
        height: '50px',
        marginTop: '1%',
        marginLeft: '40%',
        position: 'absolute',
        zIndex: 1000,
       }}
      />
     )}

    {storyPaymentReceiptResponseStatusData &&
     storyPaymentReceiptResponseStatusData?.errorStatus &&
     storyPaymentReceiptResponseStatusData.show && (
      <Alert
       type="success"
       showIcon
       closable
       message={storyPaymentReceiptResponseStatusData.message}
       style={{
        width: `${storyPaymentReceiptResponseStatusData.message ? storyPaymentReceiptResponseStatusData.message.length * 12 : 400}px`,
        height: '50px',
        marginTop: '1%',
        marginLeft: '40%',
        position: 'absolute',
        zIndex: 1000,
       }}
      />
     )}

    {data && data.length > 0 && isSuccess && (
     <div style={{ width: '100%', marginLeft: '-15px' }}>
      <DataGrid
       columns={mainColumns?.columns ? mainColumns.columns : []}
       rows={data && data.length > 0 ? StoryPaymentConvertData(data) : []}
       take={20}
       page={1}
       pagination={true}
      />
     </div>
    )}
   </BaseForm>
   {/* {isSuccess ? <TableStoryPayment data={data} isLoading={isLoading} /> : null} */}

   <SnackBar vertical="top" horizontal="center" />
  </>
 );
}

function useContractsPayment() {
 const [form] = Form.useForm();

 const [period, setPeriod] = useState<any>([
  moment().subtract(12, 'months'),
  moment(new Date()),
 ]);

 const {
  data,
  mutate: save,
  isLoading,
  isSuccess,
  error,
  reset,
 } = useMutation(srv.requestDocumentsStoryPayment, {
  onSuccess: () => {
   //form.resetFields();
  },
 });

 const onFinish = useCallback(
  (values) => {
   save({
    contractId: values.contractId,
    periodStart: values.period[0],
    periodFinish: values.period[1],
   });
  },
  [save],
 );

 const onValuesChange = useCallback(
  (value) => {
   // if (value?.period) {
   //  return;
   // }

   if (error) reset();

   const values = form.getFieldsValue();

   if (
    values &&
    values.period &&
    values.period.length > 0 &&
    values.contractId
   ) {
    save({
     contractId: values.contractId,
     periodStart: values.period[0],
     periodFinish: values.period[1],
    });

    const picker = [values.period[0], values.period[1]];

    setPeriod({
     Picker: picker,
    });

    form.setFieldsValue({
     period: picker,
    });
   }
  },
  [error, reset],
 );

 return {
  data: data?.historyPay,
  form,
  error,
  isLoading,
  isSuccess,
  onFinish,
  onValuesChange,
  period,
  setPeriod,
 };
}

function useDicts() {
 const queryClient = useQueryClient();

 const contracts = queryClient.getQueryData<Models.Contract[]>('contracts');
 const services = queryClient.getQueryData<Models.Dict[]>('services');

 return { contracts, services };
}
